export default "__VITE_ASSET__BuwMUR4p__"